import { useContext } from 'react';

import {
  type ButtonGroupContextType,
  ButtonGroupContext,
} from '../contexts/ButtonGroupContext.js';

/** @internal */
export const useButtonGroupContext = (): ButtonGroupContextType => {
  return useContext(ButtonGroupContext);
};
